import { HttpRequest } from "../../../../util/http";
import { dom } from "@fortawesome/fontawesome";

interface User {
  id: number
  email: string
  username: string
  name?: string
}
/**
 * Send notification via AWS endpoint
 * @param isNewUser
 * @param adminList
 * @param template
 * @param assignTo
 * @param assignedBy
 * @param emailTo
 * @param alertCreatedDate
 * @param alertID
 * @param source
 * @param reason
 * @param customer
 * @param secret
 * @param currentUserID
 * @param domain
 * @param membership
 * @param dueInDate
 * @param details
 */
export const notify = (
  isNewUser: boolean,
  adminList: User[],
  template: string,
  assignTo: User,
  assignedBy: User,
  emailTo: string,
  alertCreatedDate: string,
  alertID: number,
  source: string,
  reason: string,
  customer: string,
  secret: string,
  currentUserID: number,
  domain: string,
  membership: string,
  dueInDate: string,
  details: string
) => {
  if (isNewUser) {
    /**
     * 1. Send new user notification
     * 2. Send action alert notification for new user
     */

    adminList.forEach((user) => {
      if (user.id != currentUserID) {
        let adminEmailData = {
          emailData: {
            assignedByUsername: assignedBy.username,
            assignedByName: assignedBy.name ? assignedBy.name : assignedBy.username,
            assignedToName: assignTo.name ? assignTo.name : assignTo.username,
            emailTo: emailTo,
          }
        };
        sendMail(
          adminEmailData,
          "/scripts/emailHandler?route=send-new-action-alerts-only-user-added-notification"
        );
      }
    });
    const emailData= {
      emailData: {
        "assignToUsername": assignTo.username,
        "assignedByUsername": assignedBy.username,
        "assignedByName": assignedBy.name ? assignedBy.name : assignedBy.username,
        "emailTo": emailTo,
        "alertCreatedDate": alertCreatedDate,
        "alertID": alertID,
        "source": source,
        "reason": reason,
        "domain": domain,
        "dueInDate": dueInDate,
        "details": details,
        "membership": membership,
        "customer": customer
      }
    }
    sendMail(
      emailData,
      "/scripts/emailHandler?route=send-new-action-alert-notification-for-new-user"
    );
  } else {
    const emailData= {
      emailData: {
        "assignedByUsername": assignedBy.username,
        "assignedByName": assignedBy.name ? assignedBy.name : assignedBy.username,
        "emailTo": emailTo,
        "alertCreatedDate": alertCreatedDate,
        "alertID": alertID,
        "source": source,
        "reason": reason,
        "domain": domain,
        "dueInDate": dueInDate,
        "details": details,
        "membership": membership
      }
    }
    sendMail(
      emailData,
      "/scripts/emailHandler?route=send-new-action-alert-notification"
    );
  }
  return false;
};

export const sendMail = async (emailData: any, endpoint: string = ''): Promise<any> => {
  const method = 'POST';
  const data = emailData;
  return await HttpRequest.fetch(endpoint, {method, data});
}
